(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["currency-in-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    var MQ = '(max-width: 989px)';
    var mql = window.matchMedia(MQ);
    function getWidget() {
      return document.querySelector('.gemhub-currency-converter, #gemhubCurrencyWidget');
    }
    function getHeaderHome() {
      return document.querySelector('.gemhub-header-injected') ||
             document.querySelector('header.header .header__icons');
    }
    function getDrawerHome() {
      var list = document.querySelector('.ml_menu_drawer__list');
      if (!list) return null;
      var slot = list.querySelector('.ml_menu_drawer__currency');
      if (!slot) {
        slot = document.createElement('li');
        slot.className = 'ml_menu_drawer__item ml_menu_drawer__currency';
        slot.innerHTML =
          '<div class="ml_menu_drawer__currency-label">Currency</div>' +
          '<div class="ml_menu_drawer__currency-slot"></div>';
        list.appendChild(slot);
      }
      return slot.querySelector('.ml_menu_drawer__currency-slot');
    }
    function place() {
      var widget = getWidget();
      if (!widget) return;
      var target = mql.matches ? getDrawerHome() : getHeaderHome();
      if (target && widget.parentNode !== target) target.appendChild(widget);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', place);
    } else {
      place();
    }
    if (mql.addEventListener) mql.addEventListener('change', place);
    else if (mql.addListener) mql.addListener(place);
    var mo = new MutationObserver(function () {
      var w = getWidget();
      if (!w) return;
      var shouldBeIn = mql.matches ? getDrawerHome() : getHeaderHome();
      if (shouldBeIn && w.parentNode !== shouldBeIn) shouldBeIn.appendChild(w);
    });
    mo.observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
